import React from 'react';

const DataTable = ({ data, metrics, filters }) => {
    // Skip empty data
    if (!data || data.length === 0) {
        return <p>No data available</p>;
    }

    return (
        <div className="data-table-container">
            <table className="campaign-table">
                <thead>
                    <tr>
                        <th>Date</th>
                        {metrics.map(metric => (
                            <th key={metric}>
                                {metric.split('_').map(word => 
                                    word.charAt(0).toUpperCase() + word.slice(1)
                                ).join(' ')}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) => (
                        <tr key={index}>
                            <td>{row.date}</td>
                            {metrics.map(metric => (
                                <td key={metric}>
                                    {typeof row[metric] === 'number' 
                                        ? row[metric].toLocaleString()
                                        : row[metric]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default DataTable; 